import React from 'react'
import {HomepageContainer } from './homepage.styles';
import Directory from '../../component/directory/directory.compnent';

const Homepage= ()=>(
  <HomepageContainer>
    
    <Directory/> 
     
  </HomepageContainer>
);
export default Homepage